// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1342":"dab1daf8","2336":"0ec92c4e","2483":"d98e2b91","3304":"2f773733","4914":"52b271ab","6672":"2157b069","7810":"e2370593","8689":"ade41ee9"}[chunkId] + ".chunk.js";
};